import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AutenticaRequest, ValidaCodigoRequest } from '../_models/auth.model';

const KEY = 'authTokenPortalFornecedor';

@Injectable({
    providedIn: 'root',
})
export class TokenService {

    hasError: boolean = false;

    constructor(private http: HttpClient) { }

    hasToken() {
        return !!this.getToken();
    }

    autentica(credentials: AutenticaRequest): Observable<boolean> {
        return this.http.post<boolean>(
            `${environment.URL_API}/Token/Autentica`, credentials);
    }

    setToken(validacao: ValidaCodigoRequest) {

        return this.http.post(`${environment.URL_API}/Token`, validacao,
            { responseType: "text" }).pipe(
                tap(res => {
                    localStorage.setItem(KEY, res);
                })
            );
    }

    refreshToken() {
        return this.http.post(`${environment.URL_API}/Token/RefreshToken`,
            null,
            { responseType: "text" }).pipe(
                tap(res => {
                    localStorage.setItem(KEY, res);
                })
            );
    }

    getToken() {
        return localStorage.getItem(KEY);
    }

    getTokenExpirationDate(token: any): Date {
        const decoded = jwt_decode(token) as any;

        if (decoded.exp === undefined) return new Date(0);

        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;
    }

    isTokenExpired(): boolean {
        let token = this.getToken();
        if (!token) return true;

        const date = this.getTokenExpirationDate(token);
        if (date === undefined) return false;
        return !(date.valueOf() > new Date().valueOf());
    }

    logout() {
        this.removeToken();
    }

    removeToken() {
        localStorage.removeItem(KEY);
    }

    getTokenSuccess(token: string) {
        localStorage.setItem(KEY, token);
    }

    getTokenError(err: any) {
        this.hasError = true;
        console.log('erro obtendo o token: ' + err);
    }
}
